import React from 'react';
import { useTranslation } from 'react-i18next';

interface HandDrawnArrowProps {
  className?: string;
  style?: React.CSSProperties;
}

const HandDrawnArrow: React.FC<HandDrawnArrowProps> = ({ className = '', style = {} }) => {
  const { t } = useTranslation('arrow');
  return (
    <div className={`absolute pointer-events-none z-50 ${className}`} style={style}>
      <svg 
        width="160" 
        height="90" 
        viewBox="0 0 160 90" 
        xmlns="http://www.w3.org/2000/svg" 
        style={{ overflow: 'visible' }}
      >
        <defs>
          <marker 
            id="arrowhead-sketchy" 
            markerWidth="10" 
            markerHeight="7" 
            refX="0" 
            refY="3.5" 
            orient="auto"
          >
            <polygon points="0 0, 10 3.5, 0 7" fill="#facc15" />
          </marker>
        </defs>
        <path 
          d="M150 20 C 110 80, 70 30, 35 45" 
          stroke="#facc15" 
          strokeWidth="4" 
          fill="none" 
          strokeLinecap="round" 
          markerEnd="url(#arrowhead-sketchy)"
        />
        <g transform="translate(60, 20) rotate(-10)">
          <rect 
            x="0" 
            y="0" 
            width="70" 
            height="25" 
            rx="5" 
            fill="#facc15" 
          />
          <text 
            x="35" 
            y="17" 
            fontFamily="Inter, sans-serif" 
            fontSize="12px" 
            fontWeight="bold" 
            fill="#1f2937" 
            textAnchor="middle" 
            alignmentBaseline="middle"
          >
            {t('arrow.try_these')}
          </text>
        </g>
      </svg>
    </div>
  );
};

export default HandDrawnArrow;